import { boolean, struct } from 'io-ts/Decoder';

import { Id as FormulaUsageId } from '../../formula/usage/Id';
import { Id as MaterialTemplateUsageId } from '../../material-template/usage/Id';
import { Id as UsageId } from '../../usage/Id';

export const Material = struct({
	materialTemplateUsageId: MaterialTemplateUsageId,
	formulaUsageId: FormulaUsageId,
	isPreSelected: boolean,
	usageId: UsageId,
});
